import React, { Component } from 'react'
import { connect } from 'react-redux';
import classnames from "classnames";

import { profileInvalidate, profileFetchIfNeeded } from './../store/profile/actions';
import profileStatuses from './../constants/profileStatuses';
import profileStages from './../constants/profileStages';

import OrderTabQA from './OrderTabQA';
import OrderTabQANew from './OrderTabQANew';
import baseStyles from 'custom/base.styl';
import grid from 'styles/grid.styl';

import { email } from 'custom/Email';

class PageSorry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    }

    this.showGradingData = this.showGradingData.bind(this);
  }

  componentDidMount() {
    const { load } = this.props;
    load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFetching !== this.props.isFetching) {
      this.setState({ gradeData: this.props.gradeData });
    }
  }

  showGradingData() {
    this.setState({ isOpen: true });
  }

  getTitle() {
    const { status } = this.props;
    if (!status) return '';

    switch (status) {
      case profileStatuses.DELETED:
        return 'Your account is deleted'
      case profileStatuses.OUTDATED:
        return 'Your account has been closed.'
      default:
        return 'We are really sorry!'
    }
  }

  getSubtitle() {
    const { stages } = this.props;
    if (!stages) return '';

    switch (stages) {
      case profileStages.DECLINED:
      case profileStages.AWAIT_RESULT:
        return 'You have failed the test essays.'

      default:
        return 'You have failed the language test.'
    }
  }

  getText() {
    const { status } = this.props;
    if (!status) return '';

    switch (status) {
      case profileStatuses.DELETED:
        return <p className={classnames(baseStyles.content_board__text)}>As per your request, your account has been deleted. <br /> If you change your mind and, please contact our Recruiting Team at <a href={`mailto:${email}`} target='_blank' rel='noopener noreferrer'>{email}</a> <br />They will answer your questions and assist in creating a new profile.</p>
      case profileStatuses.OUTDATED:
        return <p className={classnames(baseStyles.content_board__text)}>If you want to restore your account, please contact our Recruiting Team at <a href={`mailto:${email}`} target='_blank' rel='noopener noreferrer'>{email}</a>. <br />They will be happy to provide you with access to your personal account at Livingston Research.</p>
      case profileStatuses.SANCTIONED:
        return <p className={classnames(grid.row, grid.column, grid.row_gap_20)}>
            <p className={classnames(baseStyles.content_board__text, baseStyles.mb_0)}>Unfortunately, due to international regulations,<br /> we are unable to proceed with your application.</p>
            <p className={classnames(baseStyles.content_board__text, baseStyles.light_text, baseStyles.mb_0)}>Our platform must comply with global sanctions laws, which restrict us from conducting business with individuals and entities in certain countries or regions. This is not a decision we make lightly, but rather a requirement under international regulations, including those set by the United Nations, the European Union, the United States, Australia, and other applicable authorities.</p>
            <p className={classnames(baseStyles.content_board__text, baseStyles.light_text, baseStyles.mb_0)}>For more details on these restrictions, you can check the <a href="https://ofac.treasury.gov/sanctions-programs-and-country-information" target="_blank" rel="noopener noreferrer">following page.</a></p>
            <p className={classnames(baseStyles.content_board__text, baseStyles.light_text, baseStyles.mb_0)}>We appreciate your understanding and wish you all the best in your future endeavors!</p>
          </p>
        default:
        return <p className={classnames(baseStyles.content_board__text, baseStyles.mb_80)}>Unfortunately, we cannot offer you a position right now. <br />Please, improve your skills and we will be glad to see you <br />reapplying in the next 3 months.</p>
    }
  }

  render() {
    const { gradeData, loading, status, profile } = this.props;
    const { isOpen } = this.state;

    if (loading) {
      return null;
    }

    const title = this.getTitle();
    const subtitle = this.getSubtitle();
    const hideSubtitle = status && (status === profileStatuses.DELETED || status === profileStatuses.OUTDATED);
    const extraClasses = status && status !== profileStatuses.SANCTIONED ? classnames(baseStyles.content_wide) : null;
    const extraStyles = status && status === profileStatuses.SANCTIONED ? { maxWidth: '560px', paddingBottom: '50px' } : {};

    return (
      <div className={classnames(baseStyles.content_board, baseStyles.centered, extraClasses)} style={extraStyles}>
        <div className={baseStyles.header}>
          <h2 className={baseStyles.title}>{title}</h2>
        </div>

        {!hideSubtitle &&
          <p className={classnames(baseStyles.danger_title, baseStyles.space_bottom)}>{subtitle}</p>
        }

        {this.getText()}

        {!isOpen && !!gradeData && (!!gradeData.pregrader_assessing_avg || !!gradeData.qa_report_score) &&
          <div className={baseStyles.mb_50}><a onClick={this.showGradingData}>[Check my Grading report] </a></div>
        }

        {isOpen && !!gradeData && !!gradeData.pregrader_assessing_avg &&
          <OrderTabQA order={gradeData} />
        }

        {isOpen && !!gradeData && !!gradeData.qa_report_score &&
          <OrderTabQANew order={gradeData} profile={profile} />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const activeTasks = state.profile.data && state.profile.data.user && state.profile.data.user.active_tasks;
  const task = activeTasks && activeTasks.length && activeTasks[0];
  const gradeData = task && task.user_data && task.user_data.grade;
  const loading = !state.profile.data || state.profile.isFetching;
  const stage = (state.profile.data && state.profile.data.user && state.profile.data.user.stage) || null;
  const status = (state.profile.data && state.profile.data.user && state.profile.data.user.status) || null;
  const profile = (state.profile.data && state.profile.data.user && state.profile.data.user.profile) || null;

  return {
    loading,
    gradeData,
    stage,
    status,
    profile,
  };
};

const mapDispatchToProps = dispatch => ({
  load: () => {
    dispatch(profileInvalidate());
    dispatch(profileFetchIfNeeded());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PageSorry);




// WEBPACK FOOTER //
// ./src/components/PageSorry.js